import { useSearchParams } from 'react-router-dom';
import { sectionToItemId } from './activitySections';

/**
 * L'attività da espandere nella timeline della scheda, o `null`.
 *
 * Due vie, una sola regola per Persona, Azienda e Preventivo:
 *  - il segmento `:activityId` del deep-link a un commento
 *    (`/:section/:activityId/comments/:commentId`);
 *  - il parametro `?activity=<id>` (FILO-26), con cui la ricerca globale apre
 *    un'attività sulla scheda del record collegato. È un parametro e non un
 *    segmento perché `/:section/*` resta delle sotto-rotte dei plugin.
 */
export function useActivityFocus(
  section: string | undefined,
  activityId: string | undefined,
): string | null {
  const [searchParams] = useSearchParams();
  const id = activityId ?? searchParams.get('activity') ?? undefined;
  return section && id ? sectionToItemId(section, id) : null;
}
